// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderListCellInfo_container__3mD33","orderProductTitle":"OrderListCellInfo_orderProductTitle__397yk","orderAddress":"OrderListCellInfo_orderAddress__1kfaz"};